import _JSONBig from "json-bigint"

const jsonx = _JSONBig({ useNativeBigInt: true })
export default jsonx
